'use strict';

import { queryFirst, loadScript } from './domUtil';
import { TRACKER_FUNCTIONAL_COOKIE } from './components/shippingPreference/constants';
import { initTulipChat, initAppointmentConfig } from './components/tulipchat/tulipChatConfig';

/**
 * function sets cookie in document
 * @param {string} cname Name of cookie to be set
 * @param {string} cvalue Value of cookie to be set
 */
function setCookie(cname, cvalue) {
    document.cookie = `${cname}=${cvalue}; path=/`;
}

window.addEventListener('load', (event) => {
    const isTulipEnabled = queryFirst('.js-tulip-enabled');
    if (isTulipEnabled) {
        let isTrackingEnabled = false;
        const onetrustActiveGroupsObj = window.OnetrustActiveGroups;
        if (onetrustActiveGroupsObj) {
            if (~onetrustActiveGroupsObj.indexOf(TRACKER_FUNCTIONAL_COOKIE)) {
                isTrackingEnabled = true;
            }
        }
        setCookie('tulipLiveChatAllowPageTracking', isTrackingEnabled);
        const tulipChatSrc = queryFirst('.tulip-chat-src');
        const tulipAppointmentSrc = queryFirst('.tulip-appointment-src');
        const tulipBookingSrc = queryFirst('.tulip-booking-src');
        if (tulipChatSrc) {
            const { chatScript, chatSri } = tulipChatSrc.dataset;
            loadScript(chatScript, true, chatSri).then(() => initTulipChat(tulipChatSrc.dataset.chatId, tulipChatSrc.dataset.cssOverrite));
        }
        if (tulipAppointmentSrc && tulipBookingSrc) {
            const { appointmentScript, appointmentSri } = tulipAppointmentSrc.dataset;
            const { bookingScript, bookingSri } = tulipBookingSrc.dataset;
            loadScript(appointmentScript, true, appointmentSri).then(() => initAppointmentConfig(tulipAppointmentSrc.dataset.appKey, tulipAppointmentSrc.dataset.apiBaseUrl));
            loadScript(bookingScript, true, bookingSri);
        }
    }
});
